export enum MOUSE_EVENT_TYPES {
  click = 'click', // default
  mousedown = 'mousedown'
}
